module.exports = __webpack_public_path__ + "static/media/Ram Face 3c.bf3efc21.svg";